import React from "react";
import { useLocation } from "react-router-dom";
import LinkWithLanguage from "../../reusable/LinkWithLanguage/LinkWithLanguage";
import "../Header.css";
import { PAGE_OPTIONS } from "../../../utils/constants/pageOptions"
import TEXT from "../../../utils/text/header.json";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

export default function HeaderList() {
  const location = useLocation();
  const { language } = useCurrentLanguage();

  return location.pathname === "/login" ? null : (
    <div className="header-title header-container header-main">
      <div className="header-font-size header-bold">
        <LinkWithLanguage to={"/"} content={TEXT["homepage"][language]} />
      </div>
      <div className="header-menu">
        <>
          {PAGE_OPTIONS.filter((option) => option.url !== "/").map(
            (option, i) => {
              return (
                <LinkWithLanguage
                  to={option.url}
                  className={
                    (location.pathname.includes(option.url)
                      ? "header-bold "
                      : "") + "option-button header-text-menu header-font-size"
                  }
                  content={TEXT[option.code][language]}
                  key={i}
                />
              );
            }
          )}
        </>
      </div>
    </div>
  );
}
